import { FC, useState } from 'react';
import { PostBlockProps } from '../../../../../../constants';
import { Modal } from '../../../../../commons';
import { scrollToElement } from '../../../../../../utils';
import PostBlockCard from '../../../posts/sections/PostBlocks/PostBlockCard';
import NewBlockForm from '../../../posts/sections/PostBlocks/NewBlockForm';

interface NationalParkBlocksProps {
  values: any;
  setFieldValue: any;
}

const clearNewBlockForm = (setFieldValue: any) => {
  setFieldValue('blockTitle', '');
  setFieldValue('blockDescription', '');
};

const NationalParkBlocks: FC<NationalParkBlocksProps> = ({ values, setFieldValue }) => {
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);

  const handleEditHandler = () => {
    if (selectedId !== null) {
      const block: PostBlockProps = {
        title: values.blockTitle,
        description: values.blockDescription,
      };
      const newBlocks = [...values.blocks];
      newBlocks[selectedId] = block;
      setFieldValue('blocks', newBlocks);
    }
    setIsEdit(false);
    clearNewBlockForm(setFieldValue);
  };

  const handleAddBlock = () => {
    if (isEdit) {
      handleEditHandler();
      return;
    }
    setFieldValue('blocks', [
      ...values.blocks,
      { title: values.blockTitle, description: values.blockDescription },
    ]);
    clearNewBlockForm(setFieldValue);
  };

  const onEditHandler = (id: number) => {
    setIsEdit(true);
    setSelectedId(id);
    const block = values.blocks[id];
    setFieldValue('blockTitle', block.title);
    setFieldValue('blockDescription', block.description);
    scrollToElement('park-block-edit');
  };

  const onDeleteHandler = (id: number) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const handleDeleteBlock = () => {
    const newBlocks = [...values.blocks];
    newBlocks.splice(selectedId!, 1);
    setFieldValue('blocks', newBlocks);
    setShowModal(false);
  };

  return (
    <>
      <div className='bg-[#f5f5f5] dark:bg-gray-800/50 rounded-md p-3 my-3 transition-colors' id='park-blocks'>
        <div className='flex justify-between items-center py-2'>
          <h5 className='mb-2 italic text-black dark:text-white transition-colors'>
            Park Blocks {values.blocks.length ? `(${values.blocks.length})` : ''}
          </h5>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
          {values.blocks.map((block: PostBlockProps, idx: number) => (
            <div className='col-span-1' key={block.title}>
              <PostBlockCard
                idx={idx}
                {...block}
                onDeleteHandler={() => onDeleteHandler(idx)}
                onEditHandler={() => onEditHandler(idx)}
              />
            </div>
          ))}
        </div>
        <div id='park-block-edit'>
          {values.blocks.length > 0 && (
            <div className='flex justify-center py-5'>
              <hr className='w-4/5 text-center' />
            </div>
          )}
          <NewBlockForm
            handleAddItinary={handleAddBlock}
            isEdit={isEdit}
            handleCancelEdit={() => {
              setIsEdit(false);
              clearNewBlockForm(setFieldValue);
            }}
            values={values}
            setFieldValue={setFieldValue}
          />
        </div>
      </div>
      <Modal
        size='sm'
        open={showModal}
        onClose={() => { setShowModal(false); setIsEdit(false); }}
        onSuccess={handleDeleteBlock}
        successText='Delete'
        loadingText='Saving...'
      >
        <div className='flex flex-col gap-2'>
          <h1 className='text-2xl font-semibold mb-2'>Delete Park Block</h1>
          <p className='text-tertiary mb-2'>
            Are you sure you wish to delete this block? This action is permanent and cannot be undone.
          </p>
        </div>
      </Modal>
    </>
  );
};

export default NationalParkBlocks;
